<template>
  <div class="row jipvio-dashboard">
    <div class="col-12">
      <card class="mt-70" card-body-classes="table-full-width" no-footer-line>
        <h4 class="card-title ml-20 mb-30">
          게시판 관리 > 문의사항 > 답변등록
        </h4>
        <div class="col-lg-11">
          <p class="ml-10 fl" style="width: 80%">
            문의사항 게시판 관리 페이지입니다.
          </p>
          <router-link to="/mypage/admin/board/qst">
            <el-button class="fr" icon="el-icon-menu">목록보기</el-button>
          </router-link>
        </div>
        <div class="col-12 row">
          <div class="row col-12 ml-10">
            <!-- 주소 -->
            <div class="col-sm-6 pl-0 dashbrd-el-label">
              <h5 class="fl ttl-label mr-20 mb-30">답변여부</h5>
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="Y" checked></el-checkbox>
                <el-checkbox label="N"></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="col-lg-10 mb-30 ml-10">
          <el-input class="col-md-4 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">작성자</template>
          </el-input>
          <div class="col-md-4 pl-0 mb-10 pr-10" style="display: inline-table">
            <div
              class="el-input-group__prepend"
              style="display: table-cell; padding-top: 9px; padding-bottom: 9px"
            >
              작성일
            </div>
            <div class="" style="display: table-cell">
              <el-date-picker
                class="px-0"
                v-model="value1"
                type="date"
                placeholder="작성일"
              >
              </el-date-picker>
            </div>
          </div>
          <el-input class="col-md-4 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">조회수</template>
          </el-input>
        </div>
        <div class="col-lg-10 ml-10">
          <el-input class="col-12 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">제목</template>
          </el-input>
          <h4>문의내용</h4>
          <ckeditor
            class="col-12 mb-30 pl-0"
            v-model="editorDataMemo"
            :config="editorConfig"
          ></ckeditor>
        </div>
        <h4 class="card-title pt-50 ml-20">답변내용</h4>
        <ckeditor
          class="col-lg-10 mt-30 mb-30 pl-20"
          v-model="editorDataRes"
          :config="editorConfig"
        ></ckeditor>
        <div class="col-lg-10 mb-50">
          <div class="m-auto">
            <el-button class=""> 수정 </el-button>
            <el-button class="" style="margin-left: 10px"> 삭제 </el-button>
            <el-button
              class="fr"
              icon="el-icon-circle-plus
"
              >답변등록</el-button
            >
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import card from "@/components/Cards/Card.vue";
import CKEditor from "ckeditor4-vue";
import {
  Input,
  Button,
  Checkbox,
  CheckboxGroup,
  DatePicker,
  Tag
} from "element-ui";
import kakao from "@/pages/jipvio/kakaoMap.vue";

export default {
  components: {
    card,
    ckeditor: CKEditor.component,
    [Input.name]: Input,
    [Button.name]: Button,
    kakao,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [DatePicker.name]: DatePicker,
    [Tag.name]: DatePicker
  },
  created() {
    console.log("===detail");
  },
  computed: {},
  data() {
    return {
      checkList: [""],
      checkList2: [""],
      input: "",
      editorDataMemo: "<p>내용을 입력해주세요.</p>",
      editorConfig: {
        toolbar: [
          ["Styles", "Format", "Font", "FontSize"],
          ["Bold", "Italic"],
          ["TextColor", "BGColor"],
          [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language"
          ],
          ["Table"],
          ["Link"],
          ["Undo", "Redo"],
          ["About"]
        ]
        // The configuration of the editor.
      }
    };
  },
  methods: {},
  mounted() {},
  watch: {}
};
</script>
<style>
.jipvio-dashboard .el-input__suffix {
  right: 14px;
}
div.KakaoMap > div {
  width: 100%;
}
div#map {
  width: 600px;
  height: 500px;
  margin: 0 auto !important;
}
div#map ~ button {
  display: none;
}
</style>
